import React, { useState } from "react";
import "../doctor/components/allpages.css";
import Header from "../../layouts/admin/AdminHeader";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
// import { CardDetails } from "./components/CardDetails";
import { TypeformQuestion } from "./components/TypeformQuestion";
import path from "../../path";
import { createAuditLogs } from "../../api/providerApi/providerApi";
import useHeaders from "../../helpers/useHeaders";
import useEncryption from "../../services/useEncryption";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import { useSelector } from "react-redux";
import { selectAuth } from "../../redux/slice/authSlice";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import { Tabs } from "@mui/material";
import AdminQuestionModal from "./components/AdminQuestionModal";
import { LocationQuestionListComponent } from "./components/LocationQuestionListComponent";

export const TypeFormList = () => {
  const headers = useHeaders();
  const { encryptData, decryptData } = useEncryption();
  const [search, setSearch] = useState("");
  const { selctedId } = useSelector(selectAuth);
  const [openAdd, setOpenAdd] = useState(false);
  const [update, setUpdate] = useState(false);
  const [tabValue, setTabValue] = useState("question");

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };
  return (
    <div>
      <Header pageTitle="Manage Typeform Questions" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle"></div>
        </div>
        <div className="cardcontents">
       
          <TabContext value={tabValue}>
          <Tabs
              value={tabValue}
              onChange={handleTabChange}
              className="butoontabdesigns"
              indicatorColor="none"
            >
              <Tab
                value="question"
                label="Questions"
                className={tabValue === "question" ? "actived" : ""}
              />
              <Tab
                value="location"
                label="Location Questions"
                className={tabValue === "location" ? "actived" : ""}
              />
            </Tabs>
         
            <TabPanel value="question" className="tabpanelControl">
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="searchBar">
                    <input
                      type="text"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  <Button className="btn blackoutlineBtn" onClick={() => setOpenAdd(true)}>
                    + Add Question
                  </Button>
                </div>

                <TypeformQuestion search={search} update={update} setUpdate={setUpdate} />
              </div>
            </TabPanel>

            <TabPanel value="location" className="tabpanelControl">
              <LocationQuestionListComponent />
            </TabPanel>
          </TabContext>
        </div>
      </div>
      <AdminQuestionModal
        open={openAdd}
        handleClose={() => setOpenAdd(false)}
        setUpdate={setUpdate}
      />
    </div>
  );
};
